<template>
    <div>
        <dx-grid
            url="ykcStudents"
            :columns="columns"
            :title="title"
            :selectionEnabled="true"
            :actions="actions"
            ref="grid"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
        ></dx-grid>
        <v-dialog v-model="changeClassDialog" max-width="500">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Change Class</v-card-title
                >
                <v-list>
                    <template v-for="(student, index) in selectedStudents">
                        <v-list-tile avatar ripple>
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    student.hName
                                }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider
                            v-if="index + 1 < selectedStudents.length"
                        ></v-divider>
                    </template>
                </v-list>
                <v-card-actions>
                    <v-select
                        hide-details
                        class="pr-2 ma-0"
                        :items="classes"
                        label="Class"
                        v-model="newClass"
                        box
                        item-text="`${data.item.grade} - ${data.item.teacher}`"
                    >
                        <template slot="selection" slot-scope="data">
                            {{ data.item.grade }} -
                            {{ data.item.teacher }}
                        </template>
                        <template slot="item" slot-scope="data">
                            <v-list-tile-content>
                                <v-list-tile-title
                                    v-html="
                                        `${data.item.grade} - ${
                                            data.item.teacher
                                        }`
                                    "
                                >
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </v-select>
                    <v-btn @click="changeClassDialog = false">Cancel</v-btn>
                    <v-btn
                        :disabled="!newClass.classID"
                        :loading="processing"
                        color="success"
                        @click="updateClass"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="scheduleDownloadDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Schedule Download</v-card-title>
                <v-text-field
                    ref="notificationEmail"
                    v-model="notificationEmail"
                    label="Notification Email"
                    class="px-3"
                    :rules="emailRules"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="scheduleDownloadDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="scheduleDownload"
                    >
                        download
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { formatCurrency, onlyUnique } from "../../utils/helpers.js";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";
import Pusher from "pusher-js";
import axios from "axios";

export default {
    data: () => ({
        title: "Students",
        selectionEnabled: true,
        selectedStudents: [],
        processing: false,
        classes: [],
        changeClassDialog: false,
        newClass: {},
        countries: [],
        regID: "",

        notificationEmail: "",
        scheduleDownloadDialog: false,

        emailRules: [
            (value) => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Invalid e-mail.";
            },
        ],

        columns: [
            {
                label: "Name",
                field: "name",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Last Name",
                field: "lastName",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student First Name",
                field: "engName",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "father",
                label: "Father",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "hName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Hebrew",
                field: "fatherH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Pin",
                field: "pin",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "grade",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Class",
            //     field: "class",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            // {
            //     label: "Registration Type",
            //     field: "regType",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: "NONE",
            //     selectedFilterOperation: "<>",
            // },
            // {
            //     label: "Weeks",
            //     field: "weeks",
            //     format: "",
            //     visible: true,
            //     filterType: "",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                field: "date",
                label: "Date",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "dob",
                label: "DOB",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Registration Status",
                field: "registrationStatus",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Printed",
                field: "cardPrinted",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Lunch Document",
                field: "lunchDoc",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Lunch Match Type",
                field: "lunchMatchType",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Lunch Case Num",
                field: "lunchCaseNum",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Lunch Match Record",
                field: "lunchMatchRecord",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                field: "cardPrintDate",
                label: "Card Print Date",
                type: "date",
                format: "",
                visible: false,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Immunizations",
                field: "lastImmunizationDocumentDescription",
                template: "link-action-cell-template",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Has Immunizations",
                field: "hasImmunizationRecords",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Non UTA",
                field: "nonUTA",
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: false,
            },
            {
                label: "Student ID",
                field: "studentID",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Account ID",
                link: "YKCAccountView",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cellphone",
                field: "cellPhone",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "ZipCode",
                field: "zipCode",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Code 2",
                field: "code2",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
        actions: [],
        pusher: {},
        requestID: "",
    }),
    async created() {
        // this.actions.push({
        //     text: "Print Class List",
        //     action: this.printClassList,
        // });

        this.actions.push({
            text: "Download Immunization Records",
            action: this.openScheduleDownloadDialog,
            showOnSelection: true,
        });

        // const downloadHealthRecordsAction = {
        //     text: "Download Health Records",
        //     name: "DownloadHealthRecords",
        //     loading: false,
        //     showOnSelection: true,
        // };

        // downloadHealthRecordsAction.action = () =>
        //     this.downloadHealthRecords(downloadHealthRecordsAction.loading);

        // this.actions.push(downloadHealthRecordsAction);

        this.columns.find(
            (c) => c.field == "lastImmunizationDocumentDescription",
        ).linkAction = async (student) => {
            const url = await this.$http.get(
                "/api/lapidusDayCamp/GetImmunizationsDocument?filePath=" +
                    student.lastImmunizationDocumentUrl,
            );

            return window.open(url);
        };

        this.notificationEmail = this.$store.state.authentication.user;

        await this.loadRegID();

        await this.loadClasses();
        await this.loadCountries();

        this.subscribeToPusher();
    },
    beforeDestroy() {
        this.pusher.unsubscribe("lapidus-immunizations");
    },
    methods: {
        async beforeSetupGrid() {},
        async loadRegID() {
            this.regID = await this.$http.get("api/yk/getRegID");
        },
        subscribeToPusher() {
            this.pusher = new Pusher("33b9d9d711ad50d8a7ef", {
                cluster: "mt1",
            });

            var channel = this.pusher.subscribe("yk-health-records");

            this.pusher.connection.bind("error", function(err) {
                console.log(err);
            });

            channel.bind("download-health-records", (message) => {
                this.updateHealthRecordsActionText(message);
            });
        },
        updateHealthRecordsActionText(message) {
            if (message.requestID != this.requestID) return;

            const action = this.actions.find(
                (a) => a.name == "DownloadHealthRecords",
            );

            const splitted = action.text.split("Records ");

            const text = splitted[0];

            if (!text || !splitted[1]) return;

            const total = splitted[1].split("/")[1];

            const index = +message.index;

            action.text = text + "Records " + index + "/" + total;
        },
        openDialog() {
            this.selectedStudents = this.$refs.grid.getSelectedRowsData();

            this.changeClassDialog = true;
        },
        async loadClasses() {
            const classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID,
            );

            this.classes = classes.filter((c) => {
                return c.regID.trim() == this.regID;
            });
        },
        async loadCountries() {
            this.countries = (await loadOptions("country")).map((c) => c.value);
        },
        async updateClass() {
            this.processing = true;

            const data = {
                students: this.selectedStudents.map((student) => ({
                    studentID: student.studentID,
                    classID: this.newClass.classID,
                })),
            };

            try {
                await this.$http.post(
                    "api/lapidusDayCamp/UpdateClass?user=" +
                        this.$store.state.authentication.user,
                    data,
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            this.newClass = {};

            this.changeClassDialog = false;
            this.selectedStudents = [];

            this.$refs.grid.reloadGrid();
        },
        async downloadHealthRecords() {
            const action = this.actions.find(
                (a) => a.name == "DownloadHealthRecords",
            );

            //const students = this.$refs.grid.grid.getDataSource().items();
            let students = this.$refs.grid.getSelectedRowsData();

            const columnSort = this.columns.find((c) => {
                const sort = this.$refs.grid.grid.columnOption(
                    c.field,
                    "sortOrder",
                );

                if (!sort) return false;

                return true;
            });

            if (columnSort) {
                const sortOrder = this.$refs.grid.grid.columnOption(
                    columnSort.field,
                    "sortOrder",
                );

                students = students.sort((a, b) => {
                    if (sortOrder == "desc") {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return 1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return -1;
                        }
                        return 0;
                    } else {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return -1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return 1;
                        }
                        return 0;
                    }
                });
            }

            const filteredStudents = students
                .filter((s) => s.healthFormUrl || s.healthFormUrl)
                .map((student) => student.studentID);

            if (!filteredStudents.length) {
                this.$notify({
                    group: "notification",
                    text: "No Health Records for Filetered Students.",
                    type: "warning",
                });

                return;
            }

            action.text = "Download Health Records " + "0/" + students.length;

            this.requestID = Math.floor(Math.random() * 10000000);

            try {
                const response = await this.$http({
                    url: "api/yk/getHealthDocumentsInBulk",
                    method: "POST",
                    data: {
                        students: filteredStudents,
                        classList: this.createClassListHtml(students),
                        requestID: this.requestID,
                    },
                    responseType: "blob",
                });

                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Health Records.pdf");
                document.body.appendChild(link);
                link.click();
            } catch (e) {
            } finally {
                action.text = "Download Health Records";

                this.requestID = "";
            }
        },
        async printClassList() {
            const students = this.$refs.grid.grid.getDataSource().items();

            if (!students.length) return;

            var myWindow = window.open(
                "",
                "Class List",
                "width=1000, height=1200",
            );

            myWindow.document.write(this.createClassListHtml(students));
        },
        createClassListHtml(students) {
            const showClass = students.some(
                (s) => s.class != students[0].class,
            );

            let html = `<head>
                        <style>
                        table {
                          font-family: arial, sans-serif;
                          border-collapse: collapse;
                          width: 100%;
                        }

                        .nice-text {
                            font-family: arial, sans-serif;
                        }

                        td, th {
                          border: 1px solid #dddddd;
                          text-align: left;
                          padding: 8px;
                        }

                        tr:nth-child(even) {
                          background-color: #dddddd;
                        }

                        .right-align {
                text-align: right;
            }
                        </style>
                        </head>`;

            html += `<p class="nice-text right-align">${moment().format(
                "LLL",
            )}</p>`;

            // const firstStudentClass = this.classes.find(
            //     (c) => c.classID == students[0].classID
            // );

            // const classTitle =
            //     firstStudentClass.grade + " - " + firstStudentClass.teacher;

            // html += showClass
            //     ? `<h2 class="nice-text">Class List</h2>`
            //     : `<h2 class="nice-text">Class List - ${classTitle}</h2>`;

            html += `<table>
                            <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th class="right-align">Hebrew Name</th>
                            <th class="right-align">Father</th>
                          `;

            if (showClass) {
                html += `<th>Class</th>`;
            }

            html += `<th>Grade</th>`;

            html += "</tr>";

            students
                .map((student, index) => {
                    let data = {
                        number: index + 1,
                        name: student.name,
                        hebName: student.hName,
                        fatherH: student.fatherH,
                    };

                    if (showClass) {
                        data.class = student.class;
                    }

                    data.grade = student.grade;

                    return data;
                })
                .forEach((student) => {
                    html += `<tr>`;

                    Object.entries(student).forEach((v) => {
                        const field = v[0];
                        const value = v[1];

                        html += ["hebName", "fatherH"].includes(field)
                            ? `<td class="right-align">${value}</td>`
                            : `<td>${value}</td>`;
                    });

                    html += `</tr>`;
                });

            html += `</table>`;

            return html;
        },
        onRowClicked(student) {
            this.$router.push({
                name: "YKCAccountView",
                params: {
                    id: student.accountID,
                },
                query: {
                    studentID: student.studentID,
                },
            });
        },
        openScheduleDownloadDialog() {
            this.scheduleDownloadDialog = true;
        },
        async scheduleDownload() {
            if (!this.$refs.notificationEmail.validate(true)) return;

            let students = this.$refs.grid.getSelectedRowsData();

            const columnSort = this.columns.find((c) => {
                const sort = this.$refs.grid.grid.columnOption(
                    c.field,
                    "sortOrder",
                );

                if (!sort) return false;

                return true;
            });

            if (columnSort) {
                const sortOrder = this.$refs.grid.grid.columnOption(
                    columnSort.field,
                    "sortOrder",
                );

                students = students.sort((a, b) => {
                    if (sortOrder == "desc") {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return 1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return -1;
                        }
                        return 0;
                    } else {
                        if (a[columnSort.field] < b[columnSort.field]) {
                            return -1;
                        }
                        if (a[columnSort.field] > b[columnSort.field]) {
                            return 1;
                        }
                        return 0;
                    }
                });
            }

            const studentIDs = students.map((student) => student.studentID);

            if (!studentIDs.length) {
                this.$notify({
                    group: "notification",
                    text: "No Students.",
                    type: "warning",
                });

                return;
            }

            this.requestID = Math.floor(Math.random() * 10000000);

            try {
                this.processing = true;

                const response = await this.$http({
                    url: "api/yk/scheduleFileDownload",
                    method: "POST",
                    data: {
                        students: studentIDs,
                        classList: this.createClassListHtml(students),
                        requestID: this.requestID,
                        email: this.notificationEmail,
                        user: this.$store.state.authentication.user,
                        date: moment().format("YYYY-MM-DD HH:mm:ss"),
                    },
                    responseType: "blob",
                });

                this.$notify({
                    group: "notification",
                    text: this.notificationEmail
                        ? "You will be notified once the file is ready to download"
                        : "Check back later at the file downloas page to check for the status of your file",
                    type: "success",
                });
                this.scheduleDownloadDialog = false;
            } catch (e) {
                this.processing = false;
            } finally {
                this.processing = false;

                this.requestID = "";
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
